import { render } from "./PeriodPaymentDetail.vue?vue&type=template&id=7c356800&scoped=true&lang=pug"
import script from "./PeriodPaymentDetail.vue?vue&type=script&lang=js"
export * from "./PeriodPaymentDetail.vue?vue&type=script&lang=js"

import "./PeriodPaymentDetail.vue?vue&type=style&index=0&id=7c356800&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c356800"]])

export default __exports__